import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSearchInput} from "../abstract-search-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineSearchInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-search-input",
    styleUrls: ["./inline-search-input.component.scss"],
    templateUrl: "./inline-search-input.component.html"
})
export class FUIInlineSearchInputComponent extends FUIAbstractSearchInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
